module.exports = __webpack_public_path__ + "static/media/ticket-magasin.56f90ead.png";